import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from 'i18next-browser-languagedetector'; //OPTIONAL
import Backend from "i18next-http-backend";

i18n.use(Backend)
    // .use(LanguageDetector) // OPTIONAL
    .use(initReactI18next)
    .init({
        /* lng: "pl", */
        fallbackLng: "pl",
        ns: "translation",
        defaultNS: "translation",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
